import styled from 'styled-components'

export const Section = styled.div`
  margin-top: 3rem;
`
